import { render } from "./DialogMesas.vue?vue&type=template&id=7543037c&scoped=true"
import script from "./DialogMesas.vue?vue&type=script&lang=js"
export * from "./DialogMesas.vue?vue&type=script&lang=js"

import "./DialogMesas.vue?vue&type=style&index=0&id=7543037c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7543037c"]])

export default __exports__